// theme.js — Tema claro/escuro do Editora Insigne.
// O atributo data-theme em <html> controla as CSS variables (ver App.css).
// Padrão: ESCURO (o site nasceu escuro). Preferência salva em localStorage.
const KEY = "editora-theme";

export function getTheme() {
  try {
    const t = localStorage.getItem(KEY);
    return t === "light" || t === "dark" ? t : "dark";
  } catch {
    return "dark";
  }
}

export function applyTheme(theme, animate = false) {
  const html = document.documentElement;
  if (animate) {
    html.classList.add("theme-anim");
    window.setTimeout(() => html.classList.remove("theme-anim"), 350);
  }
  html.setAttribute("data-theme", theme === "light" ? "light" : "dark");
  // Cor da barra do navegador (mobile) acompanha o tema
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", theme === "light" ? "#ffffff" : "#171843");
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* localStorage indisponível — ignora */
  }
  // Notifica componentes interessados (ex.: ícone do botão no Header)
  window.dispatchEvent(new CustomEvent("editora-theme-change", { detail: theme }));
}

export function toggleTheme() {
  const next = getTheme() === "light" ? "dark" : "light";
  applyTheme(next, true);
  return next;
}

// Aplica o tema salvo o quanto antes (chamado no index.js antes do render).
export function initTheme() {
  applyTheme(getTheme(), false);
}
